"use strict";

jQuery(function($) {

    $('body').on('checksize', function() {
        window.checkSize();
    });

    $('body').on('cart_page_refreshed', function(e, data) {
        window.addNumberFieldClickEvents();
    });

    $('body').on('removed_coupon', function(e, data) {
        window.addNumberFieldClickEvents();
    });

    $('body').on('updated_wc_div', function(e, data) {
        window.addNumberFieldClickEvents();
    });

    $('body').on('updated_checkout', function(e, data) {
        window.addCustomInputStyles('payment-buttons');
    });


    $('.woocommerce-checkout .payment_box fieldset div img').attr('style', '');

    if ( $( '.variations_form.cart' ).length ) {
        $( '.variations_form.cart' ).find( 'select[name*="attribute_"]' ).each( function() {
            if ( $( this ).val().length !== 0 ) {
                $( 'form.variations_form' ).trigger( 'check_variations', [ '', false ] );
            }
        } );
    }


    $( document ).ajaxComplete( function( event, xhr, options ) {
        //change text after deleting item in shopping basket
        if( $( ".restore-item" ).length ) {
            $( ".restore-item" ).text( "Klik hier om het ongedaan te maken." );
        }
    } );


    $('#shopcategory-filter').on('change', '[type="checkbox"]', function(evt) {
        var trg = evt.currentTarget;
        var chk = $(trg).is(':checked');
        var tag = $(document.getElementById(trg.id + '_tag'));
        var lab = tag.closest('label');

        if (chk) {
            lab.addClass('checked');
            tag.prop('checked', true);
        } else {
            lab.removeClass('checked');
            tag.prop('checked', false);
        }
    });



    //Function to the css rule
    window.checkSize = function(){
        if ($(document).width() < 992 && $( ".product_order" ).length) {
            const subscribte_el = document.querySelector('#subscribe-availability-product');

            // Check if element is already below .carousel-inner te prevent refreshing div
            if (subscribte_el !== null && subscribte_el.previousSibling !== document.querySelector('div.carousel-inner')) {
                $('#subscribe-availability-product').insertAfter(".carousel-inner");
            }
        }

        if ($(document).width() >= 992 && $( ".product_order" ).length ){
            $('#subscribe-availability-product').insertAfter("#checksize_position_1");
        }
    }

    window.checkSize();

    // run test on resize of the window
    $(window).resize(window.checkSize);


    window.addNumberFieldClickEvents = function() {

        //input number field with + - buttons
        $('.input-number-increment').off('click').on('click',function() {
    
            if ($('[data-loading-icon]').length) {
                return false;
            }
    
            var $input = $(this).parents('.input-number-group').find('.input-number');
            var val = parseInt($input.val(), 10);
            $input.val(val + 1);
            $input.trigger("change");
        });
    
        $('.input-number-decrement').off('click').on('click',function() {
    
            if ($('[data-loading-icon]').length) {
                return false;
            }
    
            var $input = $(this).parents('.input-number-group').find('.input-number');
            var val = parseInt($input.val(), 10);
            $input.val(val - 1);
            $input.trigger("change");
        });
    }

    window.addNumberFieldClickEvents();
});